import range from 'lodash/range';
import type { onSort, sorter } from './table.types';
import { Sort } from './table.types';

export const getSortProps = (
  cellId: string,
  sorter: sorter,
  onSort: onSort,
) => {
  return {
    sortable: true,
    active: sorter.cellId === cellId,
    sort: sorter.direction,
    onSortToggle: () => onSort(cellId),
    defaultSort: Sort.desc,
  };
};

export const getTableSelectionIndices = (
  currentSelectIndex: number,
  lastSelectedIndex: number,
) => {
  return currentSelectIndex > lastSelectedIndex
    ? range(lastSelectedIndex, currentSelectIndex + 1)
    : range(currentSelectIndex, lastSelectedIndex + 1);
};

export const getRowAnimationProps = (index: number) => ({
  initial: {
    opacity: 0,
    translateX: Math.min(index * 5, 100),
  },
  animate: { opacity: 1, translateX: 0 },
  transition: { duration: 0.4, ease: 'easeOut' },
});

export const getRowDefaultProps = () => ({
  initial: {
    opacity: 1,
    translateX: 0,
  },
  animate: { opacity: 1, translateX: 0 },
  transition: { duration: 0 },
});
